import { render, staticRenderFns } from "./DetailsImage.vue?vue&type=template&id=ab83833e"
import script from "./DetailsImage.vue?vue&type=script&lang=js"
export * from "./DetailsImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports